function padNumber(value) {
  return value < 10 ? `0${value}` : String(value);
}

function initCountdown(el) {
  if (el.dataset.countdownBound) return;
  el.dataset.countdownBound = 'true';

  const startMs = el.dataset.startDate ? Number(el.dataset.startDate) * 1000 : null;
  const endMs = el.dataset.endDate ? Number(el.dataset.endDate) * 1000 : null;

  const daysValue = el.querySelector('[data-unit="days"]');
  const hoursValue = el.querySelector('[data-unit="hours"]');
  const minutesValue = el.querySelector('[data-unit="minutes"]');
  const secondsValue = el.querySelector('[data-unit="seconds"]');

  let intervalId;

  function tick() {
    const now = Date.now();

    if ((startMs && now < startMs) || (endMs && now >= endMs)) {
      el.hidden = true;

      if (endMs && now >= endMs) {
        clearInterval(intervalId);
      }

      return;
    }

    el.hidden = false;

    const totalSeconds = Math.max(0, Math.floor((endMs - now) / 1000));
    const days = Math.floor(totalSeconds / 86400);
    const hours = Math.floor((totalSeconds % 86400) / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    if (daysValue) daysValue.textContent = padNumber(days);
    if (hoursValue) hoursValue.textContent = padNumber(hours);
    if (minutesValue) minutesValue.textContent = padNumber(minutes);
    if (secondsValue) secondsValue.textContent = padNumber(seconds);
  }

  tick();
  intervalId = setInterval(tick, 1000);
}

function initAllCountdowns() {
  document.querySelectorAll('[data-countdown-banner]').forEach(initCountdown);
}

document.addEventListener('DOMContentLoaded', initAllCountdowns);
document.addEventListener('shopify:section:load', initAllCountdowns);
